import forOwn from 'mout/object/forOwn'

/**
 * Outputs the correct answer using the answers object from activeItem.
 * @param {object} answers from activeItem 
 * @returns {string} the correct answerID
 */
export default function getCorrectAnswer (answers) {
  let correctAnswer = ''
  forOwn(answers, (val, key, o) => {
    if (val.correct) {
      correctAnswer = key
    }
  })
  return correctAnswer
}


// WEBPACK FOOTER //
// ./src/helpers/assessment/getCorrectAnswer.js